import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IoMdTrash } from 'react-icons/io'
import { Alert } from '@wellbeingxltd/fe-lib/components'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { useConfirm } from '@wellbeingxltd/fe-lib/hooks'
import { Button } from 'components'
import { VouchersActions } from 'store/models/vouchers'

export const ActionsField = ({ values }) => {
    const dispatch = useDispatch()
    const { deleteVouchersLoading, selectedVouchers } = useSelector(GET_STORE.VOUCHERS)
    const confirmDelete = useConfirm({ text: `Do you want to delete voucher ?` })

    const removeHandler = async ({ uuid, productId, supplierId }) => {
        const body = { vouchersDetails: !!selectedVouchers.length ? selectedVouchers : [{ uuid, productId, supplierId }] }
        const result = await confirmDelete(body)
        if (result) {
            dispatch(
                VouchersActions.deleteVouchers(body, (msg, type) => {
                    Alert(msg, type)
                    dispatch(VouchersActions.getVouchersDetails())
                })
            )
        }
    }

    if (!values.used) {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Button {...{ loading: deleteVouchersLoading, onClick: () => removeHandler(values) }}>
                    <IoMdTrash />
                </Button>
            </div>
        )
    }
    return null
}
